import { SharingPermissionTerms } from "consts";

const buildSharingPermissionTerms = (): ["none", "read", "write"] => {
  return [SharingPermissionTerms.NONE, SharingPermissionTerms.READ, SharingPermissionTerms.WRITE];
};

export default buildSharingPermissionTerms;
